import { Box, Link, SpaceBetween } from '@cloudscape-design/components';
import { Grid } from '@cloudscape-design/components';
import { Container } from '@cloudscape-design/components';
import { User } from '../common/types';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

export function ReportCardLogo() {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  return (
    <Link
      href={isAuthenticated ? '/' : '/create'}
      onFollow={() => {
        navigate(isAuthenticated ? '/' : '/create');
      }}
    >
      <img
        src="https://img.review-alerts.com/production/635fff10933d24ba71737b9f/635fff10933d24ba71737b9f/9fefeade-bc17-43a0-bfec-1d6e04768e5f.png"
        height="100"
        style={{ maxWidth: '350px', height: '100px' }}
        alt="Real Time Feedback Logo"
      />
    </Link>
  );
}

export default function ReportCardHeader(props: { user?: User }) {
  const { user } = props;
  // TODO get phone number from user
  const email = user?.email || 'reputation@realtimefeedback.com';

  return (
    <Container>
      <Grid
        gridDefinition={[
          {
            colspan: {
              default: 12,
              xxs: 6,
            },
          },
          {
            colspan: {
              default: 12,
              xxs: 6,
            },
          },
        ]}
      >
        <div>
          <ReportCardLogo />
        </div>
        <div className="text-right">
          <SpaceBetween direction="vertical" size="xxxs">
            <Box variant="p" fontWeight="heavy" color="text-label">
              Contact us to schedule a demo:
            </Box>
            <Box variant="p">
              <Link href={`mailto:${email}`} color="inverted">
                {email}
              </Link>
            </Box>
            <Box variant="p">
              <Link href="tel:1-888-294-1411" color="inverted">
                (888) 294-1411
              </Link>
            </Box>
          </SpaceBetween>
        </div>
      </Grid>
    </Container>
  );
}
